import { MessageOption } from "@/types/conversationTypes";

interface Props {
  option: MessageOption;
}

const EventOption = ({ option }: Props) => {
  const details = option.eventDetails;
  const { title, description, date, city, url, image } = details;

  return (
    <div className="p-4 border border-brand-100 rounded-xl bg-white shadow-sm text-xs flex gap-4">
      {image && (
        <img
          src={image}
          alt={title || 'Event image'}
          className="w-20 h-20 rounded object-cover border border-gray-200"
          loading="lazy"
          onError={(e) => { e.currentTarget.style.visibility = 'hidden'; }}
        />
      )}
      <div className="flex-1 flex flex-col gap-1 min-w-0">
        {title && (
          <h3 className="text-sm font-semibold text-gray-900 leading-tight truncate" title={title}>{title}</h3>
        )}
        {date && (
          <p className="text-[11px] text-brand-600 font-medium">{date}</p>
        )}
        {(city) && (
          <p className="text-[11px] text-gray-600">{city}</p>
        )}
        {description && (
          <p className="text-[11px] text-gray-700 line-clamp-3" title={description}>{description}</p>
        )}
        {url && (
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-1 inline-flex items-center text-[11px] text-brand-600 hover:text-brand-700 font-medium underline decoration-brand-300 decoration-[1.5px] underline-offset-[3px]"
          >
            More details
          </a>
        )}
      </div>
    </div>
  );
};

export default EventOption;
